import axios from 'axios';
import Qs from 'qs';
import isLocalhost from '@/js/utils/isLocalhost';

export default new class http {
  constructor() {
    const $html = document.querySelector('html');
    this.token = $html.dataset.token;

    this.service = axios.create(http.getConfig());

    if (this.token) {
      this.service.defaults.headers['X-TOKEN'] = this.token;

      if (isLocalhost) {
        this.service.defaults.baseURL = 'http://base-elements-new-pdp-31437.demo.book24.ru/';
      }
    }
  }

  static getConfig() {
    return {
      baseURL: '/',
    };
  }

  get(path, payload = {}) {
    return new Promise((resolve, reject) => {
      this.service.request({
        method: 'GET',
        url: path,
        params: payload,
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  post(path, payload = {}, isTransformRequest = false, isParamsSerializer = false) {
    return new Promise((resolve, reject) => {
      const config = {
        method: 'POST',
        url: path,
        data: payload,
      };

      if (isTransformRequest) {
        Object.assign(config, {
          transformRequest(data) {
            return Qs.stringify(data);
          },
        });
      }

      if (isParamsSerializer) {
        Object.assign(config, {
          paramsSerializer(params) {
            return Qs.stringify(params);
          },
        });
      }

      this.service.request(config)
        .then((response) => {
          resolve(response.data);
        })
        .catch(error => reject(error));
    });
  }

  delete(path, payload) {
    return new Promise((resolve, reject) => {
      this.service.request({
        method: 'DELETE',
        url: path,
        data: payload,
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  download(path) {
    return new Promise((resolve, reject) => {
      this.service.request({
        method: 'GET',
        url: path,
        responseType: 'blob',
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  upload(path, file) {
    const formData = new FormData();
    formData.append('file', file);

    return new Promise((resolve, reject) => {
      this.service.request({
        method: 'POST',
        url: path,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  put(path, payload = {}) {
    return new Promise((resolve, reject) => {
      this.service.request({
        method: 'PUT',
        url: path,
        data: payload,
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
}();
